import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

import type { NavMainProps } from './main/nav/types';

// ----------------------------------------------------------------------

export const navData: NavMainProps['data'] = [
  { title: 'Hjem', path: '/', icon: <Iconify width={22} icon="solar:home-angle-bold-duotone" /> },
  {
    title: 'Produkter',
    path: paths.product.root,
    icon: <Iconify width={22} icon="eva:star-fill" />,
  },
  {
    title: 'Handelsbetingelser',
    icon: <Iconify width={22} icon="ic:round-view-list" />,
    path: paths.betingelser,
  },
  {
    title: 'Kontakt',
    icon: <Iconify width={22} icon="solar:phone-bold" />,
    path: paths.contact,
  },
];
